import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "choosed-docs-container" }
const _hoisted_2 = { class: "doc_block" }
const _hoisted_3 = { class: "doc_block-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasketIcon = _resolveComponent("BasketIcon")!
  const _component_shadow_block = _resolveComponent("shadow-block")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (doc, idx) => {
      return (_openBlock(), _createBlock(_component_shadow_block, {
        key: `cdoc_${idx}`,
        class: "doc-container"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(doc.name), 1),
            _createVNode(_component_BasketIcon, {
              onClick: ($event: any) => (_ctx.$emit('delete-item', idx))
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}